(() => {
  'use strict';
  if (window.__lorvyoCatalog) return;
  window.__lorvyoCatalog = true;
  const chooseImage = (scope, id, scroll = true) => {
    if (!id) return;
    const slide = [...scope.querySelectorAll('[data-image-id]')].find(el => el.dataset.imageId === id);
    if (!slide) return;
    if (scroll) {const grid=matchMedia('(min-width:990px)').matches;slide.parentElement.scrollTo({left:grid?0:slide.offsetLeft-slide.parentElement.offsetLeft,top:grid?slide.offsetTop-slide.parentElement.offsetTop:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    scope.querySelectorAll('[data-catalog-image]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.catalogImage === id)));
  };
  const changeVariant = select => {
    const scope = select.closest('[data-catalog-product]'), option = select.selectedOptions[0];
    if (!scope || !option) return;
    scope.querySelectorAll('[data-catalog-variant-name]').forEach(el => el.textContent = select.hidden ? '' : option.textContent.replace(/ — .*$/, ''));
    scope.querySelectorAll('[data-catalog-price]').forEach(el => el.textContent = option.dataset.price);
    scope.querySelectorAll('[data-catalog-compare]').forEach(el => el.textContent = option.dataset.compare || '');
    const buttons = scope.querySelectorAll('[data-catalog-add],[data-order-now]');
    buttons.forEach(button=>{
    if (button) {button.disabled=option.dataset.available!=='true';button.querySelector('span').textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;}
    });
    chooseImage(scope, option.dataset.imageId);
    const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
  };
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-catalog-variant]')) changeVariant(event.target);
    if(event.target.matches('[data-catalog-sort]')) event.target.form.requestSubmit();
  });
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-catalog-image]');
    if(button)chooseImage(button.closest('[data-catalog-product]'),button.dataset.catalogImage);
  });
  const initialize = root => root.querySelectorAll('[data-catalog-product]').forEach(scope=>{
    if(scope.dataset.catalogReady)return;
    scope.dataset.catalogReady='true';
    const gallery=scope.querySelector('[data-gallery]');
    let ticking=false;
    gallery?.addEventListener('scroll',()=>{if(ticking||matchMedia('(min-width:990px)').matches)return;ticking=true;requestAnimationFrame(()=>{const index=Math.round(gallery.scrollLeft/((gallery.children[0]?.offsetWidth||gallery.clientWidth)+10));chooseImage(scope,gallery.children[index]?.dataset.imageId,false);ticking=false;});},{passive:true});
    const select=scope.querySelector('[data-catalog-variant]');
    if(select && new URL(location.href).searchParams.has('variant'))changeVariant(select);
    const form=scope.querySelector('.lv-product-form');
    const sticky=scope.querySelector('[data-catalog-sticky]');
    if (form && sticky && 'IntersectionObserver' in window) {
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        sticky.hidden=entry.isIntersecting || entry.boundingClientRect.bottom>0;
      }),{threshold:0});
      observer.observe(form);
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target.contains(scope))observer.disconnect();
      },{once:true});
    }
    if(form && select)new MutationObserver(()=>{select.disabled=form.dataset.pending==='true';}).observe(form,{attributes:true,attributeFilter:['data-pending']});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document));else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
